import React from 'react';
import styles from './index.module.scss';
import ContactsBlock from './contacts_block';

const CallbackBtn = ({ contentData, path_to_folder }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const blocks = Array.isArray(contentData) ? contentData : [];
  const firstBlockContent = blocks[0]?.block_content;
  const imageContent = Array.isArray(firstBlockContent)
    ? firstBlockContent.find((c) => (c.cotent_type === 'img' || c.content_type === 'img') && c.img_name && c.img_name !== 'none')
    : null;
  const processedImgName =
    imageContent?.img_name && imageContent.img_name.includes('\\')
      ? imageContent.img_name.substring(imageContent.img_name.lastIndexOf('\\') + 1)
      : imageContent?.img_name;
  const imgSrc = path_to_folder && processedImgName ? path_to_folder + processedImgName : null;

  return (
    <>
      <button
        type='button'
        className={styles.callback_btn}
        onClick={() => setIsOpen(true)}
        aria-label='Открыть контакты'>
        {imgSrc && (
          <img src={imgSrc} alt='Кнопка обратной связи' className={styles.callback_btn_image} />
        )}
        <span className={styles.callback_btn_text}>Связаться</span>
      </button>

      {isOpen && (
        <div className={styles.modalOverlay} onClick={() => setIsOpen(false)} role='presentation'>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button
              type='button'
              className={styles.closeButton}
              onClick={() => setIsOpen(false)}
              aria-label='Закрыть'>
              ×
            </button>
            <div className={styles.container}>
              <div className={styles.modalBody}>
                <div className={styles.modalBodyInner}>
                  {blocks.length > 0 ? (
                    blocks.map((blockData, index) => (
                      <ContactsBlock
                        key={index}
                        blockData={blockData}
                        path_to_folder={path_to_folder}
                        blockIndex={index}
                        compactDescription
                        hideMetaDisclaimer
                      />
                    ))
                  ) : (
                    <p className={styles.description}>Контакты</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CallbackBtn;
